import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core'
import { ComponentModeEnum } from '../enums/component-mode.enum'

@Directive({
    selector: '[ifEditMode]',
    standalone: false
})
export class EditModeDirective {
    constructor(
        @Inject(TemplateRef) private templateRef: TemplateRef<any>,
        @Inject(ViewContainerRef) private viewContainer: ViewContainerRef
    ) { }

    @Input() set ifEditMode(mode: ComponentModeEnum) {
        this.viewContainer.clear()
        if (mode === ComponentModeEnum.EDIT) {
            this.viewContainer.createEmbeddedView(this.templateRef)
        }
    }
}